export default __webpack_public_path__ + "static/media/deal-1.442738d4.webp";